import { Editor } from '@tiptap/react';
import { useCallback } from 'react';

import { useGlobalTheme } from 'shared/utils/useGlobalTheme';

import { WidgetDefaultStyles, TypographyType } from '../typographyStyles';

export const useTextStyles = (editor: Editor | null) => {
  const theme = useGlobalTheme();

  const getTextStyleProp = useCallback(
    (
      prop: 'color' | 'lineHeight' | 'fontFamily' | 'fontSize',
      options?: {
        defaultStyles?: WidgetDefaultStyles;
      }
    ) => {
      if (!editor) return null;

      const elementStyle = editor.getAttributes('textStyle');

      if (elementStyle[prop]) {
        return elementStyle[prop];
      }

      for (let level = 1; level < 4; level++) {
        if (editor.getAttributes('heading').level === level.toString()) {
          const levelTag =
            level === 1 ? TypographyType.Title : level === 2 ? TypographyType.Headline : TypographyType.SubHeadline;

          if (prop === 'fontFamily') {
            return theme.other.fonts[levelTag].fontFamily;
          }

          if (prop === 'color' || prop === 'fontSize') {
            return options?.defaultStyles?.[levelTag][prop] ?? theme.other.fonts[levelTag][prop];
          }

          return theme.other.fonts[levelTag][prop];
        }
      }
      if (prop === 'color') {
        return options?.defaultStyles?.bodyText[prop] ?? theme.other.fonts.bodyText[prop];
      }
      return theme.other.fonts.bodyText[prop];
    },
    [theme.other, editor]
  );

  return {
    getTextStyles: getTextStyleProp
  };
};
